import ThirdPartyCreatedModal from "./ThirdPartyCreatedModal.container";

export default ThirdPartyCreatedModal;
